module.exports = __webpack_public_path__ + "static/media/6-AirHeatExchanger - No cool - Water heat.ec786795.png";